<template>
  <div>
    <div class="pb-20">
      <el-button type="primary" @click="vue_pop_show_hide(true)">添加登陆账号</el-button>
    </div>
    <el-table :data="list" border stripe>
      <el-table-column label="ID" prop="id" width="80px"></el-table-column>
      <el-table-column label="登陆账号" prop="username"></el-table-column>
      <el-table-column label="密码" prop="password"></el-table-column>
      <el-table-column label="姓名" prop="realname" ></el-table-column>
      <el-table-column label="手机号码" prop="mobile"></el-table-column>
      <el-table-column label="创建时间" prop="addtime"></el-table-column>
      <el-table-column label="操作" width="220px">
        <template v-slot="scope">
          <el-button type="primary" @click="edit(scope.row.id)" size="small" style="margin-right: 10px;">编辑</el-button>
          <el-popconfirm title="确定删除？" @confirm="del(scope.row.id)">
            <el-button type="danger" size="small" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <LayerPop title="添加/编辑登陆账号" @close="vue_pop_show_hide" v-if="is_pop">
      <div>
        <el-form label-width="120px" ref="post" :model="post" :rules="rules">
          <el-form-item label="登陆账号" prop="username" >
            <el-input placeholder="登陆账号" v-model.trim="post.username" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password" >
            <el-input placeholder="密码" v-model="post.password" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="realname" >
            <el-input placeholder="姓名" v-model="post.realname" style="width:200px;"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="mobile" >
            <el-input placeholder="手机号码" v-model="post.mobile" style="width:200px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submit">确定提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </LayerPop>
  </div>
</template>

<script>
import LayerPop from "@/components/layer-pop";

export default {
  name: "admin",
  components:{LayerPop},
  data(){
    return{
      list:[],
      is_pop : false,
      rules : {
        username : [{required : true, message : '请填写', trigger : 'blur'}],
      },
      post : {
        id : 0,
        username : '',
        password : '',
        realname : '',
        mobile : '',
      },
    }
  },
  mounted:async function(){
    let that = this;
    that.get_list();
  },
  methods:{
    get_list:async function (){
      let that = this;
      try{
        this.$_showLoading();
        let res = await this.$_api.company('admin_list',{uid:that.user.uid});
        console.log(res);
        if (res.errcode == 0){
          this.list = res.list;
        }else{
          this.list = [];
        }
        this.$_hideLoading();
      }catch (e){
        console.log(e);
        return false;
      }
    },
    edit:async function (id){
      this.$_showLoading();
      let res = await this.$_api.company('admin_detail',{id:id});
      this.$_hideLoading();
      if (res.errcode == 0){
        this.post = res.post;
        this.is_pop = true;
      }
    },
    submit:function (){
      try{
        let that = this;
        let post = that.post;
        let method = 'admin_add';
        if (post.id == 0){
          if (!post.password){
            this.$_showToastNone('请填写密码');
            return ;
          }
        }
        this.$refs.post.validate(async function  (check){
          if (check){
            if(that.post['id']){
              method = 'admin_edit';
            }
            that.$_showLoading();
            post.create_uid = that.user.uid;
            let res = await that.$_api.company(method, post);
            that.$_hideLoading();
            if (res.errcode == 0){
              that.$_showToast(res.errmsg);
              that.is_pop = false;
              that.post = {};
              that.get_list();
            }else{
              that.$_showToastNone(res.errmsg);
            }
          }
        },)
      }catch (e) {
        console.log(e);
      }
    },
    del:async function (id){
      let that = this;
      that.$_showLoading();
      let res = await that.$_api.company('admin_del', {id:id});
      that.$_hideLoading();
      if (res.errcode == 0) {
        that.$_showToast(res.errmsg);
        that.get_list();
      }
    }
  },
}
</script>

<style scoped>

</style>